const $ede1e6694b13a411$export$3f521420530811cf = {
    FRAME_CONTAINER_ID: "methodFrameContainer",
    IFRAME_NAME: "methodIframe",
    FORM_NAME: "threeDSMethodForm",
    INPUT_NAME: "threeDSMethodData"
};
const $ede1e6694b13a411$export$9aef2de9a9febd46 = {
    FRAME_CONTAINER_ID: "challengeFrameContainer",
    IFRAME_NAME: "challengeIframe",
    FORM_NAME: "threeDSCReqForm"
};
const $ede1e6694b13a411$export$909c260dfc8c4a = {
    IFRAME: "iframe",
    REDIRECT: "redirect"
};
const $ede1e6694b13a411$export$a831561ce8167be0 = "BT-API-KEY";
const $ede1e6694b13a411$export$e575008eba482a0 = "BT-TRACE-ID";
const $ede1e6694b13a411$export$c3ee1e672e1e24e7 = "https://api.basistheory.com";
const $ede1e6694b13a411$export$c823725bfc2e0c49 = "https://3ds.basistheory.com";
const $ede1e6694b13a411$export$16a30e6d25dd54ab = "pages/method.html";
const $ede1e6694b13a411$export$260aceedd9fe5f81 = "pages/challenge.html";



let $9baa5c7531c09ef3$var$disableTelemetry = false;
const $9baa5c7531c09ef3$export$bfcc8eb13073c803 = ({ disableTelemetry: disableTelemetryArg })=>{
    $9baa5c7531c09ef3$var$disableTelemetry = disableTelemetryArg;
};
const $9baa5c7531c09ef3$export$af88d00dbe7f521 = (()=>{
    const ddTok = "pubb96b84a13912504f4354f2d794ea4fab";
    const log = async (message, level, error, attributes = {})=>{
        if ($9baa5c7531c09ef3$var$disableTelemetry) return;
        const payload = {
            application: "3ds-web",
            ddsource: "3ds-web",
            service: "3ds-web",
            ...attributes,
            level: level,
            message: level === "error" && error ? `${message}: ${error.message}` : message
        };
        try {
            const response = await fetch(`https://http-intake.logs.datadoghq.com/v1/input/${ddTok}`, {
                method: "POST",
                body: JSON.stringify(payload),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (!response.ok) throw new Error("Network response was not ok");
        } catch  {
        // Do nothing
        }
    };
    return {
        log: {
            error: (message, error, attributes)=>log(message, "error", error, attributes),
            info: (message, attributes)=>log(message, "info", undefined, attributes),
            warn: (message, attributes)=>log(message, "warn", undefined, attributes)
        }
    };
})();


var $12389938bc382e86$export$f73e2cb993c10d36;
(function(WindowSizeId) {
    WindowSizeId["ONE"] = "01";
    WindowSizeId["TWO"] = "02";
    WindowSizeId["THREE"] = "03";
    WindowSizeId["FOUR"] = "04";
    WindowSizeId["FIVE"] = "05";
})($12389938bc382e86$export$f73e2cb993c10d36 || ($12389938bc382e86$export$f73e2cb993c10d36 = {}));
const $12389938bc382e86$var$stringifyValue = (val)=>{
    if (val === null || val === undefined) return "";
    return JSON.stringify(val);
};
const $12389938bc382e86$export$fa80f116bca647aa = ()=>{
    const validColorDepths = [
        1,
        4,
        8,
        15,
        16,
        24,
        32,
        48
    ];
    const actualColorDepth = window.screen.colorDepth;
    const possibleValues = validColorDepths.filter((val)=>val <= actualColorDepth);
    if (possibleValues.length === 0) return validColorDepths[0];
    return Math.max(...possibleValues);
};
const $12389938bc382e86$export$524b4f5938fca0ea = (c)=>c?.split("-").slice(0, 2).join("-");
const $12389938bc382e86$export$a5202107d3e3cdb0 = ()=>({
        browserColorDepth: $12389938bc382e86$var$stringifyValue($12389938bc382e86$export$fa80f116bca647aa()),
        browserJavascriptEnabled: true,
        browserJavaEnabled: window.navigator.javaEnabled(),
        browserLanguage: $12389938bc382e86$export$524b4f5938fca0ea(window.navigator.language),
        browserScreenHeight: $12389938bc382e86$var$stringifyValue(window.screen.height),
        browserScreenWidth: $12389938bc382e86$var$stringifyValue(window.screen.width),
        browserTZ: $12389938bc382e86$var$stringifyValue(new Date().getTimezoneOffset()),
        browserUserAgent: window.navigator.userAgent
    });
const $12389938bc382e86$export$d96f5f7405a82f1b = (challengeWindowSize = "05")=>{
    const sizeMap = {
        ["01"]: [
            "250px",
            "400px"
        ],
        ["02"]: [
            "390px",
            "400px"
        ],
        ["03"]: [
            "500px",
            "600px"
        ],
        ["04"]: [
            "600px",
            "400px"
        ],
        ["05"]: [
            "100%",
            "100%"
        ]
    };
    const size = sizeMap[challengeWindowSize];
    if (size) return size;
    else {
        const err = new Error(`Window size ${challengeWindowSize} is not supported`);
        (0, $9baa5c7531c09ef3$export$af88d00dbe7f521).log.error("Unsupported window size", err);
        throw err;
    }
};



const $c64965f72f06da5e$var$isHTMLElement = (obj)=>!obj || obj instanceof HTMLElement;
const $c64965f72f06da5e$export$eca25244f8f7df8e = (container, name, id, width = "0", height = "0", onLoadCallback)=>{
    if (!$c64965f72f06da5e$var$isHTMLElement(container) || !name || !id) {
        const msg = `Unable to create iframe. Container must be a HTML element ${JSON.stringify(container)} ${name} ${id}`;
        (0, $9baa5c7531c09ef3$export$af88d00dbe7f521).log.error(`Unable to create iframe`, new Error());
        throw Error(msg);
    }
    const iframe = document.createElement("iframe");
    iframe.name = name;
    iframe.width = width;
    iframe.height = height;
    iframe.setAttribute("id", id);
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("border", "0");
    if (onLoadCallback && typeof onLoadCallback === "function") iframe.addEventListener("onload", onLoadCallback);
    container.appendChild(iframe);
    return iframe;
};
const $c64965f72f06da5e$export$f681a8129d2e9d28 = (formName, formAction, formTarget)=>{
    const form = document.createElement("form");
    form.name = formName;
    form.action = formAction;
    form.method = "POST";
    form.target = formTarget;
    return form;
};
const $c64965f72f06da5e$export$d80fffb1deb3b97e = (name, value)=>{
    const input = document.createElement("input");
    input.name = name;
    input.value = value;
    return input;
};
const $c64965f72f06da5e$export$c8a8987d4410bf2d = (tagName, child)=>{
    const element = document.createElement(tagName);
    element.appendChild(child);
    return element;
};
const $c64965f72f06da5e$export$b824392d62597b74 = (id, /**
   * Sets display none on the iframe container
   */ hidden = false)=>{
    let container;
    // check if container exists and just wipe content
    container = document.getElementById(id);
    if (container) {
        container.innerHTML = "";
        if (hidden) container.setAttribute("style", "display:none;");
        return;
    }
    container = document.createElement("div");
    container.id = id;
    if (hidden) container.setAttribute("style", "display:none;");
    document.body.appendChild(container);
};
const $c64965f72f06da5e$export$78907e7ba1b6c00e = (ids)=>ids?.map((id)=>document.getElementById(id)?.remove());


const $fa75e9b184a0a110$var$convertCasing = (obj, transformKey)=>{
    const convertCase = (input)=>{
        if (typeof input === "string") return transformKey(input);
        if (typeof input !== "object" || input === null) return input;
        if (Array.isArray(input)) return input.map(convertCase);
        return Object.fromEntries(Object.entries(input).map(([key, value])=>[
                transformKey(key),
                typeof value === "object" || Array.isArray(value) ? convertCase(value) : value
            ]));
    };
    return convertCase(obj);
};
const $fa75e9b184a0a110$export$3561b44d041d13c = (obj)=>$fa75e9b184a0a110$var$convertCasing(obj, (val)=>val.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase());
const $fa75e9b184a0a110$export$72d485cca95ce2e2 = (obj)=>$fa75e9b184a0a110$var$convertCasing(obj, (val)=>val.replace(/_./g, (match)=>match[1].toUpperCase()));


const $bb80761c88de0bf5$export$c564cdbbe6da493 = (obj)=>btoa(JSON.stringify(obj)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");




const $263638c749818df0$export$7d6f1c8842f9f527 = (()=>{
    let _apiKey;
    let _baseUrl;
    const client = async (method, path, body, correlationId)=>{
        if (!_apiKey) throw Error("Missing api key");
        if (_baseUrl) (0, $9baa5c7531c09ef3$export$af88d00dbe7f521).log.info(`Using custom api base url in 3DS SDK ${_baseUrl}`);
        const additional_headers = {};
        if (correlationId) additional_headers[0, $ede1e6694b13a411$export$e575008eba482a0] = correlationId;
        return await fetch(`${_baseUrl ?? (0, $ede1e6694b13a411$export$c3ee1e672e1e24e7)}/3ds${path}`, {
            method: method,
            body: JSON.stringify(body),
            headers: {
                [(0, $ede1e6694b13a411$export$a831561ce8167be0)]: _apiKey,
                "Content-Type": "application/json",
                ...additional_headers
            }
        });
    };
    const init = (apiKey, baseUrl)=>{
        _apiKey = apiKey;
        _baseUrl = baseUrl;
    };
    return {
        client: client,
        init: init
    };
})();



var $9e6eab7e85fe68ea$export$9130146a86a85749;
(function(NotificationType) {
    NotificationType["METHOD"] = "method";
    NotificationType["CHALLENGE"] = "challenge";
    NotificationType["METHOD_TIME_OUT"] = "methodTimeout";
    NotificationType["START_METHOD_TIME_OUT"] = "startMethodTimeout";
    NotificationType["ERROR"] = "error";
})($9e6eab7e85fe68ea$export$9130146a86a85749 || ($9e6eab7e85fe68ea$export$9130146a86a85749 = {}));
const $9e6eab7e85fe68ea$export$5e14cdade93d6f7b = (notification)=>window.postMessage(notification, "*");
const $9e6eab7e85fe68ea$export$c1c631b5969e899b = (obj)=>typeof obj === "object" && obj !== null && "isCompleted" in obj && typeof obj.isCompleted === "boolean" && "id" in obj && typeof obj.id === "string" && "type" in obj && Object.values($9e6eab7e85fe68ea$export$9130146a86a85749).includes(obj.type);







const $b7edf56a6b60e294$var$getIframeId = (type)=>({
        [(0, $9e6eab7e85fe68ea$export$9130146a86a85749).CHALLENGE]: (0, $ede1e6694b13a411$export$9aef2de9a9febd46).IFRAME_NAME,
        [(0, $9e6eab7e85fe68ea$export$9130146a86a85749).METHOD]: (0, $ede1e6694b13a411$export$3f521420530811cf).IFRAME_NAME,
        [(0, $9e6eab7e85fe68ea$export$9130146a86a85749).METHOD_TIME_OUT]: (0, $ede1e6694b13a411$export$3f521420530811cf).IFRAME_NAME,
        [(0, $9e6eab7e85fe68ea$export$9130146a86a85749).ERROR]: `${(0, $ede1e6694b13a411$export$3f521420530811cf).IFRAME_NAME},${(0, $ede1e6694b13a411$export$9aef2de9a9febd46).IFRAME_NAME}`,
        [(0, $9e6eab7e85fe68ea$export$9130146a86a85749).START_METHOD_TIME_OUT]: ""
    })[type]?.split(",");
const $b7edf56a6b60e294$export$c41ae42ecc348abb = (session)=>{
    let timeout;
    return new Promise((resolve, reject)=>{
        const handleMessage = (event)=>{
            if ((0, $9e6eab7e85fe68ea$export$c1c631b5969e899b)(event.data)) {
                if (event.data.type === (0, $9e6eab7e85fe68ea$export$9130146a86a85749).ERROR) {
                    (0, $9baa5c7531c09ef3$export$af88d00dbe7f521).log.error(`Error occurred during session creation: ${event?.data?.details}`);
                    reject(new Error(`An error occurred during session creation: ${event?.data?.details}`));
                    (0, $c64965f72f06da5e$export$78907e7ba1b6c00e)($b7edf56a6b60e294$var$getIframeId(event.data?.type));
                    clearTimeout(timeout);
                } else if (event.data.type === (0, $9e6eab7e85fe68ea$export$9130146a86a85749).START_METHOD_TIME_OUT) timeout = setTimeout(()=>{
                    (0, $9e6eab7e85fe68ea$export$5e14cdade93d6f7b)({
                        id: event.data.id,
                        type: (0, $9e6eab7e85fe68ea$export$9130146a86a85749).METHOD_TIME_OUT,
                        isCompleted: false
                    });
                }, 10000);
                else if (event.data.type === (0, $9e6eab7e85fe68ea$export$9130146a86a85749).CHALLENGE) ;
                else if (!event.isTrusted) ;
                else {
                    // handle session creation event
                    window.removeEventListener("message", handleMessage);
                    const toResponse = (event)=>{
                        const transformedSession = (0, $fa75e9b184a0a110$export$72d485cca95ce2e2)(session);
                        const response = {
                            id: event.data.id,
                            cardBrand: transformedSession.cardBrand,
                            correlationId: transformedSession.correlationId
                        };
                        if (transformedSession.additionalCardBrands) response.additionalCardBrands = transformedSession.additionalCardBrands;
                        return response;
                    };
                    const response = toResponse(event);
                    resolve(response);
                    (0, $c64965f72f06da5e$export$78907e7ba1b6c00e)($b7edf56a6b60e294$var$getIframeId(event.data?.type));
                    clearTimeout(timeout);
                }
            }
        };
        window.addEventListener("message", handleMessage);
    });
};


const $36674fed137cfc63$var$errorMessagesMap = {
};
const $36674fed137cfc63$var$validationErrorMessagesMap = {
    "The card was not supported by any card schemes": "3DS is not supported for the provided card"
};
const $36674fed137cfc63$var$isValidationApiError = (error)=>{
    return "errors" in error && error.errors !== undefined && typeof error.errors === "object" && error.errors !== null;
};
const $36674fed137cfc63$export$89d83cc97c52a37 = (error)=>{
    return typeof error === "object" && error !== null && ("title" in error || "status" in error || "detail" in error);
};
const $36674fed137cfc63$export$1e46c02a50c8708f = (apiError)=>{
    if ($36674fed137cfc63$var$isValidationApiError(apiError)) for (const errorKey of Object.keys(apiError.errors)){
        if ($36674fed137cfc63$var$validationErrorMessagesMap[errorKey]) throw new Error($36674fed137cfc63$var$validationErrorMessagesMap[errorKey]);
    }
    else if (apiError.status === 424 && apiError.error) {
        // handle 3DS service error case
        const errorParts = [];
        if (apiError.error.message) errorParts.push(apiError.error.message);
        if (apiError.error.details) errorParts.push("details: " + apiError.error.details);
        const errorMessage = errorParts.length > 0 ? errorParts.join(" - ") : apiError.title || "An unknown 3DS service error occurred";
        throw new Error(errorMessage);
    } else {
        if (apiError.title && $36674fed137cfc63$var$errorMessagesMap[apiError.title]) throw new Error($36674fed137cfc63$var$errorMessagesMap[apiError.title]);
    }
    // if no matching mapping is found, throw a generic error
    throw new Error(apiError.title || "An unknown error occurred");
};



/**
 * @deprecated This function is deprecated and will be removed in the next major version.
 */ const $2bc795de5a692819$var$submitMethodRequestRedirect = (threeDSMethodURL, threeDSServerTransID, methodNotificationURL)=>{
    const threeDSMethodDataBase64 = (0, $bb80761c88de0bf5$export$c564cdbbe6da493)({
        threeDSServerTransID: threeDSServerTransID,
        threeDSMethodNotificationURL: `${methodNotificationURL}?mode=redirect`
    });
    const newWindow = window.open("", "threeDSMethodForm");
    if (!newWindow) {
        console.error("Popup blocked or unable to open the window.");
        return;
    }
    const form = (0, $c64965f72f06da5e$export$f681a8129d2e9d28)((0, $ede1e6694b13a411$export$3f521420530811cf).FORM_NAME, threeDSMethodURL, "threeDSMethodForm");
    form.appendChild((0, $c64965f72f06da5e$export$d80fffb1deb3b97e)((0, $ede1e6694b13a411$export$3f521420530811cf).INPUT_NAME, threeDSMethodDataBase64));
    document.body.appendChild(form);
    form.submit();
    // check periodically if method window is closed (it closes immediatelly on completion)
    const checkClosedInterval = window.setInterval(()=>{
        if (newWindow.closed) {
            clearInterval(checkClosedInterval);
            (0, $9e6eab7e85fe68ea$export$5e14cdade93d6f7b)({
                isCompleted: true,
                id: threeDSServerTransID,
                type: (0, $9e6eab7e85fe68ea$export$9130146a86a85749).METHOD
            });
        }
    }, 500);
};
const $2bc795de5a692819$var$submitMethodRequest = (threeDSMethodURL, threeDSServerTransID, methodNotificationURL)=>{
    const threeDSMethodDataBase64 = (0, $bb80761c88de0bf5$export$c564cdbbe6da493)({
        threeDSServerTransID: threeDSServerTransID,
        threeDSMethodNotificationURL: methodNotificationURL
    });
    const container = document.getElementById((0, $ede1e6694b13a411$export$3f521420530811cf).FRAME_CONTAINER_ID);
    const iframe = (0, $c64965f72f06da5e$export$eca25244f8f7df8e)(container, (0, $ede1e6694b13a411$export$3f521420530811cf).IFRAME_NAME, (0, $ede1e6694b13a411$export$3f521420530811cf).IFRAME_NAME, "0", "0");
    iframe.src = `${0, $78b3785cefa2a9d4$export$7cd62790311d5c9}/${0, $ede1e6694b13a411$export$16a30e6d25dd54ab}`;
    iframe.onload = ()=>{
        iframe.contentWindow?.postMessage({
            type: "startMethod",
            threeDSMethodURL: threeDSMethodURL,
            threeDSMethodData: threeDSMethodDataBase64
        }, "*");
    };
};
const $2bc795de5a692819$var$makeSessionRequest = async ({ tokenId: tokenId, tokenIntentId: tokenIntentId, pan: pan, skipMethodRequest: skipMethodRequest = false, methodRequestMode: methodRequestMode, challengeMode: challengeMode, correlationId: correlationId })=>{
    const providedParams = [
        pan,
        tokenId,
        tokenIntentId
    ].filter((param)=>param !== undefined);
    if (providedParams.length === 0) throw new Error("One of pan, tokenId, or tokenIntentId is required.");
    if (providedParams.length > 1) throw new Error("Only one of pan, tokenId, or tokenIntentId should be provided.");
    const sessionParamKey = pan ? "pan" : tokenId ? "tokenId" : "tokenIntentId";
    const sessionParamValue = pan || tokenId || tokenIntentId;
    const deviceInfo = (0, $12389938bc382e86$export$a5202107d3e3cdb0)();
    const response = await (0, $263638c749818df0$export$7d6f1c8842f9f527).client("POST", `/sessions`, (0, $fa75e9b184a0a110$export$3561b44d041d13c)({
        [sessionParamKey]: sessionParamValue,
        device: "browser",
        deviceInfo: deviceInfo,
        webChallengeMode: challengeMode
    }), correlationId);
    if (!response.ok) {
        let json;
        try {
            json = await response.json();
        } catch  {
            const msg = `Failed to parse error response. HTTP Status: ${response.status}`;
            (0, $9baa5c7531c09ef3$export$af88d00dbe7f521).log.error(msg);
            throw new Error(msg);
        }
        if ((0, $36674fed137cfc63$export$89d83cc97c52a37)(json)) (0, $36674fed137cfc63$export$1e46c02a50c8708f)(json);
        else {
            const msg = `An unknown error occurred while creating session. Status: ${response.status}.`;
            (0, $9baa5c7531c09ef3$export$af88d00dbe7f521).log.error(`${msg} Response: ${JSON.stringify(json, null, 2)}`);
            throw new Error(msg);
        }
    }
    const session = (0, $fa75e9b184a0a110$export$72d485cca95ce2e2)(await response.json());
    session.correlationId = response.headers?.get((0, $ede1e6694b13a411$export$e575008eba482a0)) || "";
    (0, $9baa5c7531c09ef3$export$af88d00dbe7f521).log.info(`3DS session response received with ID ${session.id}`);
    if (session.methodUrl && !skipMethodRequest) {
        (0, $9e6eab7e85fe68ea$export$5e14cdade93d6f7b)({
            isCompleted: false,
            id: session.id,
            type: (0, $9e6eab7e85fe68ea$export$9130146a86a85749).START_METHOD_TIME_OUT
        });
        if (methodRequestMode === (0, $ede1e6694b13a411$export$909c260dfc8c4a).REDIRECT) $2bc795de5a692819$var$submitMethodRequestRedirect(session.methodUrl, session.id, session.methodNotificationUrl);
        else $2bc795de5a692819$var$submitMethodRequest(session.methodUrl, session.id, session.methodNotificationUrl);
    }
    return session;
};
const $2bc795de5a692819$export$f7c62c73429afa28 = async ({ tokenId: tokenId, tokenIntentId: tokenIntentId, pan: pan, skipMethodRequest: skipMethodRequest = false, methodRequestMode: methodRequestMode = (0, $ede1e6694b13a411$export$909c260dfc8c4a).IFRAME, challengeMode: challengeMode = (0, $ede1e6694b13a411$export$909c260dfc8c4a).IFRAME, correlationId: correlationId = "" })=>{
    const session = await $2bc795de5a692819$var$makeSessionRequest({
        tokenId: tokenId,
        tokenIntentId: tokenIntentId,
        pan: pan,
        skipMethodRequest: skipMethodRequest,
        methodRequestMode: methodRequestMode,
        challengeMode: challengeMode,
        correlationId: correlationId
    }).catch((error)=>{
        return Promise.reject(error.message);
    });
    // skip message handling, no method request necessary
    if (!session.methodUrl || skipMethodRequest) {
        const response = {
            id: session.id,
            cardBrand: session.cardBrand
        };
        if (session.additionalCardBrands) response.additionalCardBrands = session.additionalCardBrands;
        return response;
    }
    return await (0, $b7edf56a6b60e294$export$c41ae42ecc348abb)(session);
};








const $0db30e8bab82ecdb$export$8181f6b5c58f6044 = (timeout = 60000)=>{
    let timeoutId;
    return new Promise((resolve, reject)=>{
        const handleMessage = (event)=>{
            if ((0, $9e6eab7e85fe68ea$export$c1c631b5969e899b)(event.data)) {
                if (event.data.type === (0, $9e6eab7e85fe68ea$export$9130146a86a85749).ERROR) {
                    (0, $9baa5c7531c09ef3$export$af88d00dbe7f521).log.error(`Error occurred during challenge: ${event?.data?.details}`);
                    reject(new Error(`An error occurred during challenge: ${event?.data?.details}`));
                    (0, $c64965f72f06da5e$export$78907e7ba1b6c00e)([
                        (0, $ede1e6694b13a411$export$9aef2de9a9febd46).IFRAME_NAME
                    ]);
                    clearTimeout(timeout);
                } else if (event.data.type === (0, $9e6eab7e85fe68ea$export$9130146a86a85749).CHALLENGE) {
                    clearTimeout(timeoutId);
                    window.removeEventListener("message", handleMessage);
                    const toResponse = (event)=>({
                            id: event.data.id,
                            isCompleted: event.data.isCompleted,
                            authenticationStatus: event.data.authenticationStatus
                        });
                    const response = toResponse(event);
                    (0, $9baa5c7531c09ef3$export$af88d00dbe7f521).log.info(`${event.data.type} notification received for session: ${response.id}`);
                    resolve(response);
                    (0, $c64965f72f06da5e$export$78907e7ba1b6c00e)([
                        (0, $ede1e6694b13a411$export$9aef2de9a9febd46).IFRAME_NAME
                    ]);
                } else event.isTrusted;
            }
        };
        window.addEventListener("message", handleMessage);
        timeoutId = setTimeout(()=>{
            window.removeEventListener("message", handleMessage);
            reject(new Error("Timed out waiting for a challenge response. Please try again."));
            (0, $c64965f72f06da5e$export$78907e7ba1b6c00e)([
                (0, $ede1e6694b13a411$export$9aef2de9a9febd46).IFRAME_NAME
            ]);
        }, timeout);
    });
};






function $d6091d0740832a34$var$isAcsThreeDSChallengeRequest(obj) {
    const { messageType: messageType, messageVersion: messageVersion, threeDSServerTransID: threeDSServerTransID, acsTransID: acsTransID, challengeWindowSize: challengeWindowSize } = obj;
    return typeof obj === "object" && obj !== null && typeof messageType === "string" && typeof messageVersion === "string" && typeof threeDSServerTransID === "string" && typeof acsTransID === "string" && Object.values((0, $12389938bc382e86$export$f73e2cb993c10d36)).includes(challengeWindowSize);
}
const $d6091d0740832a34$var$submitChallengeRequest = (acsURL, creq, containerId)=>{
    const container = document.getElementById(containerId ?? (0, $ede1e6694b13a411$export$9aef2de9a9febd46).FRAME_CONTAINER_ID);
    const windowSize = (0, $12389938bc382e86$export$d96f5f7405a82f1b)(creq.challengeWindowSize);
    const creqBase64 = (0, $bb80761c88de0bf5$export$c564cdbbe6da493)(creq);
    const challengeIframeName = (0, $ede1e6694b13a411$export$9aef2de9a9febd46).IFRAME_NAME;
    const challengeIframe = (0, $c64965f72f06da5e$export$eca25244f8f7df8e)(container, challengeIframeName, challengeIframeName, windowSize[0], windowSize[1]);
    challengeIframe.src = `${0, $78b3785cefa2a9d4$export$7cd62790311d5c9}/${0, $ede1e6694b13a411$export$260aceedd9fe5f81}`;
    challengeIframe.onload = ()=>{
        challengeIframe.contentWindow?.postMessage({
            type: "startChallenge",
            acsURL: acsURL,
            creq: creqBase64
        }, "*");
    };
};
/**
 * @deprecated This method is deprecated and will be removed in the next major version
 */ const $d6091d0740832a34$var$submitChallengeRequestRedirect = (acsURL, creq)=>{
    const windowSize = (0, $12389938bc382e86$export$d96f5f7405a82f1b)(creq.challengeWindowSize);
    const newWindow = window.open("", "threeDSChallenge", `width=${windowSize[0]},height=${windowSize[1]}`);
    if (!newWindow) throw new Error("Popup blocked or unable to open the window.");
    const creqBase64 = (0, $bb80761c88de0bf5$export$c564cdbbe6da493)(creq);
    const form = (0, $c64965f72f06da5e$export$f681a8129d2e9d28)((0, $ede1e6694b13a411$export$9aef2de9a9febd46).FORM_NAME, acsURL, "threeDSChallenge");
    const creqInput = (0, $c64965f72f06da5e$export$d80fffb1deb3b97e)("creq", creqBase64);
    form.appendChild(creqInput);
    document.body.appendChild(form);
    form.submit();
};
const $d6091d0740832a34$var$makeChallengeRequest = ({ sessionId: sessionId, acsTransactionId: acsTransactionId, acsChallengeUrl: acsChallengeUrl, threeDSVersion: threeDSVersion, windowSize: windowSize, mode: mode, containerId: containerId })=>{
    if (!sessionId) throw new Error("Session ID is required");
    const creq = {
        messageType: "CReq",
        messageVersion: threeDSVersion,
        threeDSServerTransID: sessionId,
        acsTransID: acsTransactionId,
        challengeWindowSize: windowSize ?? (0, $12389938bc382e86$export$f73e2cb993c10d36).THREE
    };
    if ($d6091d0740832a34$var$isAcsThreeDSChallengeRequest(creq)) {
        if (mode === (0, $ede1e6694b13a411$export$909c260dfc8c4a).REDIRECT) $d6091d0740832a34$var$submitChallengeRequestRedirect(acsChallengeUrl, creq);
        else $d6091d0740832a34$var$submitChallengeRequest(acsChallengeUrl, creq, containerId);
    } else {
        const err = `Invalid challenge request payload for session: ${sessionId}`;
        (0, $9baa5c7531c09ef3$export$af88d00dbe7f521).log.error(err);
        return Promise.reject(new Error(err));
    }
    return Promise.resolve({
        id: sessionId
    });
};
const $d6091d0740832a34$export$452d4d807a279e0d = async ({ sessionId: sessionId, acsTransactionId: acsTransactionId, acsChallengeUrl: acsChallengeUrl, threeDSVersion: threeDSVersion, windowSize: windowSize, mode: mode = "iframe", timeout: timeout = 60000, containerId: containerId })=>{
    await $d6091d0740832a34$var$makeChallengeRequest({
        sessionId: sessionId,
        acsTransactionId: acsTransactionId,
        acsChallengeUrl: acsChallengeUrl,
        threeDSVersion: threeDSVersion,
        windowSize: windowSize,
        mode: mode,
        containerId: containerId
    }).catch((error)=>{
        return Promise.reject(error.message);
    });
    return (0, $0db30e8bab82ecdb$export$8181f6b5c58f6044)(timeout);
};





let $78b3785cefa2a9d4$export$7cd62790311d5c9 = (0, $ede1e6694b13a411$export$c823725bfc2e0c49);
const $78b3785cefa2a9d4$export$30207c6d2c13b02b = (()=>{
    return (apiKey, configOptions)=>{
        try {
            (0, $9baa5c7531c09ef3$export$bfcc8eb13073c803)({
                disableTelemetry: configOptions?.disableTelemetry ?? false
            });
            (0, $c64965f72f06da5e$export$b824392d62597b74)((0, $ede1e6694b13a411$export$3f521420530811cf).FRAME_CONTAINER_ID, true);
            (0, $c64965f72f06da5e$export$b824392d62597b74)((0, $ede1e6694b13a411$export$9aef2de9a9febd46).FRAME_CONTAINER_ID);
        } catch (error) {
            (0, $9baa5c7531c09ef3$export$af88d00dbe7f521).log.error("Unable to create iframe container", error);
        }
        $78b3785cefa2a9d4$export$7cd62790311d5c9 = configOptions?.sdkBaseUrl ?? (0, $ede1e6694b13a411$export$c823725bfc2e0c49);
        (0, $263638c749818df0$export$7d6f1c8842f9f527).init(apiKey, configOptions?.apiBaseUrl);
        return {
            createSession: $2bc795de5a692819$export$f7c62c73429afa28,
            startChallenge: $d6091d0740832a34$export$452d4d807a279e0d
        };
    };
})();
window.BasisTheory3ds = $78b3785cefa2a9d4$export$30207c6d2c13b02b;


export {$78b3785cefa2a9d4$export$7cd62790311d5c9 as sdkBaseUrl, $78b3785cefa2a9d4$export$30207c6d2c13b02b as BasisTheory3ds};
